import { useTranslation } from '@/services/i18n'
import React, { memo, useRef } from 'react'
import { checkIsPrivateKey, formatRSAPubKey } from '@/utils/setting'
import styles from './UploadRsa.module.scss'
import { message } from 'antd'

interface ChildProps {
  success: (keyStr: string) => void
  isShow?: boolean
}
const UploadRsa = memo<ChildProps>(props => {
  const { t } = useTranslation()
  const { success, isShow } = props
  const [messageApi, contextHolder] = message.useMessage()
  const fileInputRef = useRef<HTMLInputElement>(null)
  function triggerUpload() {
    fileInputRef.current?.click()
  }
  function handleChange(ev: any) {
    const { files } = ev.target

    if (!files) return
    readAndParsePem(files)
  }
  function uploadFileContent(content: string) {
    success(content)
  }
  function readAndParsePem(files: any[]) {
    const postFiles = Array.prototype.slice.call(files)
    if (postFiles.length === 0) {
      return
    }
    const rawFile = postFiles[0]
    const reader = new FileReader()
    reader.onload = (oFREvent: any) => {
      const pointsTxt = oFREvent.target.result as string
      const isPrivateKey = checkIsPrivateKey(pointsTxt)
      if (isPrivateKey) {
        messageApi.open({
          type: 'warning',
          content: t('rule.PrivateKey'),
        })
      } else {
        const resolvedTxt = formatRSAPubKey(pointsTxt)
        uploadFileContent(resolvedTxt)
      }
    }
    reader.onerror = () => {
      messageApi.open({
        type: 'warning',
        content: t('rule.errorKey'),
      })
    }
    reader.readAsText(rawFile)
    fileInputRef.current!.value = ''
  }
  return (
    <div className={styles.upload_rsa_key}>
      {contextHolder}
      {isShow && (
        <span className={styles.upload_btn} onClick={triggerUpload}>
          {t('api.uploadPubkey')}
        </span>
      )}
      <input
        ref={fileInputRef}
        type="file"
        accept=".pem"
        className={styles.upload_input}
        onChange={handleChange}
      />
    </div>
  )
})

export default UploadRsa
